export default "__VITE_ASSET__BRZUj7Kd__"